import { useState, useCallback, useEffect } from "react";
import { apiService } from "../services/apiClient";
import { apiUrl } from "../services/apiUrl";
import { getToken } from "../components/auth/authConfig";

export const useVerifyUser = () => {
  const alreadyVerified = localStorage.getItem("user-verified") === "true";
  const [isLoading, setIsLoading] = useState(alreadyVerified ? false : true);
  const [isAuth, setIsAuth] = useState(alreadyVerified ? true : false);

  const logout = useCallback(() => {
    try {
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
    } catch (error) {
      console.error("Logout failed", error);
    }
  }, []);

  const verifyCurrentUser = useCallback(async () => {
    const token = await getToken();
    if (!token) {
      logout();
      return;
    }

    setIsLoading(true);
    setIsAuth(false);

    try {
      const userEmail = localStorage.getItem("myemail");
      const response = await apiService.post(apiUrl.verifyUser(), { email: userEmail });
      const json = response.data;

      if (json?.success && json?.isAuthorized) {
        localStorage.setItem("user-verified", "true");
        setIsAuth(true);
      } else {
        setIsAuth(false);
        setTimeout(logout, 3000);
      }
    } catch {
      setIsAuth(false);
      setTimeout(logout, 3000);
    } finally {
      setIsLoading(false);
    }
  }, [logout]);

  useEffect(() => {
    if (alreadyVerified) return;
    verifyCurrentUser();
  }, [verifyCurrentUser, alreadyVerified]);

  return { isLoading, isAuth };
};
